import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=bb549ff4"
import script from "./group.js?vue&type=script&lang=js&external"
export * from "./group.js?vue&type=script&lang=js&external"
import style0 from "./group.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports